import * as React from 'react';
import styles from './index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FDrawer from '@/components/FDrawer';
import { Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';

interface FEditLabelsDrawerProps {
  text: string;

  onClose?(): void;

  onConfirm?(text: FEditLabelsDrawerProps['text']): void;
}

function FEditLabelsDrawer({ text, onClose, onConfirm }: FEditLabelsDrawerProps) {

  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(true);
  const [$text, set$text, get$text] = FUtil.Hook.useGetState<string>(text);
  const [$textError, set$textError, get$textError] = FUtil.Hook.useGetState<string>('');

  const [$changed, set$changed, get$changed] = FUtil.Hook.useGetState<boolean>(false);

  AHooks.useDebounceEffect(() => {
    set$text(text);
  }, [text], {
    wait: 100,
  });

  return (<FDrawer
    title={'编辑简介'}
    onClose={() => {
      set$open(false);
    }}
    open={$open}
    width={580}
    afterOpenChange={(o) => {
      if (!o) {
        onClose?.();
      }
    }}
    topRight={<Space size={30}>
      <FComponentsLib.FTextBtn
        type='default'
        onClick={async () => {
          if (get$changed()) {
            const bool: boolean = await fPromiseModalConfirm({
              title: '提示',
              description: '还没有保存，现在离开会导致信息丢失',
              okText: FI18n.i18nNext.t('btn_leave'),
              cancelText: FI18n.i18nNext.t('btn_cancel'),
            });
            if (bool) {
              set$open(false);
            }
          } else {
            set$open(false);
          }
        }}
      >取消</FComponentsLib.FTextBtn>
      <FComponentsLib.FRectBtn
        type='primary'
        disabled={$text.length > 200 || !$changed}
        onClick={() => {
          onConfirm?.(get$text());
          set$open(false);
        }}
      >保存</FComponentsLib.FRectBtn>
    </Space>}
  >

    <FComponentsLib.FInput.FMultiLine
      value={$text}
      lengthLimit={200}
      onChange={(e) => {
        set$text(e.target.value);
        set$changed(true);
      }}
    />

    {
      $textError !== '' && (<>
        <div style={{ height: 5 }} />
        <div style={{ color: '#EE4040' }}>{$textError}</div>
      </>)
    }
  </FDrawer>);
}

export default FEditLabelsDrawer;
